<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card elevation="">
          <v-card-title class="justify-center"> LOG DE CORREOS AUTOMÁTICOS </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <div class="col-12">
                <p>
                  <router-link
                    exact=""
                    style="text-decoration: none"
                    :to="{ name: 'inicioPanel' }"
                    >Inicio</router-link
                  >
                  /
                  <router-link
                    exact=""
                    style="text-decoration: none"
                    :to="{ name: 'correosAutomaticosPanel' }"
                    >Correos Automáticos</router-link
                  >
                </p>
              </div>

              <v-col cols="12">
                <v-btn
                  small
                  title="Limpiar filtros"
                  fab
                  dark
                  color="blue-grey"
                  depressed
                  @click="limpiarFiltros()"
                >
                  <v-icon dark>mdi-refresh</v-icon>
                </v-btn>
              </v-col>

              <v-col xl="2" lg="2" md="3" sm="6" cols="12">
                <v-select
                  v-model="cmbCantidadRegistros"
                  item-text="texto"
                  item-value="valor"
                  :items="arrCantidadRegistros"
                  label="Cantidad de registros"
                  @change="listarRegistros(1)"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <v-col xl="2" lg="2" md="3" sm="6" cols="12">
                <v-select
                  v-model="cmbEstado"
                  :items="arrEstados"
                  item-text="texto"
                  item-value="valor"
                  label="Estado"
                  @change="listarRegistros(1)"
                  dense
                  outlined
                  clearable
                ></v-select>
              </v-col>
              <v-col xl="4" lg="4" md="6" sm="12" cols="12">
                <v-select
                  v-model="cmbRegla"
                  :items="arrReglas"
                  item-value="regla"
                  :item-text="textoRegla"
                  label="Disparador"
                  @change="listarRegistros(1)"
                  dense
                  outlined
                  clearable
                ></v-select>
              </v-col>
              <v-col xl="2" lg="2" md="6" sm="6" cols="12">
                <v-text-field
                  v-model="iptFechaDesde"
                  type="date"
                  label="Desde"
                  dense
                  outlined
                  clearable
                  @change="listarRegistros(1)"
                ></v-text-field>
              </v-col>
              <v-col xl="2" lg="2" md="6" sm="6" cols="12">
                <v-text-field
                  v-model="iptFechaHasta"
                  type="date"
                  label="Hasta"
                  dense
                  outlined
                  clearable
                  @change="listarRegistros(1)"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  dense
                  label="Buscar por correo o asunto"
                  prepend-icon="mdi-magnify"
                  clearable
                  type="text"
                  v-model="iptBuscarRegisro"
                  @keyup.enter="listarRegistros(1)"
                  @click:clear="
                    iptBuscarRegisro = '';
                    listarRegistros(1);
                  "
                ></v-text-field>
              </v-col>

              <v-col cols="12" v-show="arrRegistrosTabla.length > 0">
                <v-simple-table dense="" fixed-header="" ref="tblListado">
                  <template v-slot:default>
                    <thead class="text-no-wrap">
                      <tr>
                        <th>FECHA</th>
                        <th>CORREO</th>
                        <th>ASUNTO</th>
                        <th>DISPARADOR</th>
                        <th>ESTADO</th>
                        <th>INTENTOS</th>
                        <th>ERROR</th>
                      </tr>
                    </thead>
                    <tbody class="text-no-wrap">
                      <tr
                        v-for="item in arrRegistrosTabla"
                        :key="item.idcorreo_automatico_envio"
                      >
                        <td v-text="$moment(item.fecha_envio).format('DD/MM/YYYY')"></td>
                        <td v-text="item.email"></td>
                        <td v-text="item.asunto"></td>
                        <td v-text="item.regla"></td>
                        <td>
                          <v-chip small dark :color="colorEstado(item.estado)">
                            {{ item.estado }}
                          </v-chip>
                        </td>
                        <td v-text="item.intentos"></td>
                        <td v-text="item.error"></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

                <p class="mt-3">
                  Mostrando del registro <span v-text="primerRegistro"></span> al
                  <span v-text="ultimoRegistro"></span> de un total de
                  <span v-text="totalRegistro"></span> filas
                </p>
              </v-col>

              <v-col cols="12 text-center" v-show="loaderListado">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  :size="100"
                  :width="7"
                ></v-progress-circular>
              </v-col>

              <v-col cols="12" v-show="arrRegistrosTabla.length > 0">
                <v-pagination
                  circle
                  v-model="paginaActual"
                  :length="cantidadPaginas"
                  :total-visible="7"
                  @input="listarRegistros(paginaActual)"
                  :disabled="loaderListado"
                ></v-pagination>
              </v-col>

              <v-col cols="12" v-show="alertRegistroNoEcontrado">
                <v-alert type="error" dense outlined class="text-center">
                  NO HAY REGISTROS DISPONIBLES PARA MOSTRAR
                </v-alert>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      arrCantidadRegistros: [
        { texto: 10, valor: 10 },
        { texto: 30, valor: 30 },
        { texto: 50, valor: 50 },
        { texto: 100, valor: 100 },
        { texto: 500, valor: 500 },
      ],
      arrEstados: [
        { texto: "Enviado", valor: "enviado" },
        { texto: "Fallido", valor: "fallido" },
        { texto: "Pendiente", valor: "pendiente" },
        { texto: "Omitido", valor: "omitido" },
      ],
      arrReglas: [],
      loaderListado: false,
      alertRegistroNoEcontrado: false,
      cmbCantidadRegistros: 30,
      cmbEstado: null,
      cmbRegla: null,
      iptFechaDesde: null,
      iptFechaHasta: null,
      iptBuscarRegisro: "",
      arrRegistrosTabla: [],
      paginaActual: 1,
      cantidadPaginas: 1,
      primerRegistro: 0,
      ultimoRegistro: 0,
      totalRegistro: 0,
    };
  },

  methods: {
    textoRegla(item) {
      const base = item.base === "cuenta" ? "cuenta creada" : "última compra";
      return `${item.regla} · ${base} hace ${item.dias} días`;
    },

    colorEstado(estado) {
      return (
        { enviado: "success", fallido: "error", pendiente: "warning", omitido: "grey" }[
          estado
        ] || "grey"
      );
    },

    listarRegistros(pagina = null) {
      this.arrRegistrosTabla = [];
      this.loaderListado = true;
      this.alertRegistroNoEcontrado = false;
      this.axios({
        method: "GET",
        url: "api/panel/correosAutomaticos",
        params: {
          cantidadRegistros: this.cmbCantidadRegistros,
          paginaActual: pagina,
          iptBuscarRegisro: this.iptBuscarRegisro,
          estado: this.cmbEstado,
          regla: this.cmbRegla,
          fechaDesde: this.iptFechaDesde,
          fechaHasta: this.iptFechaHasta,
        },
      })
        .then((response) => {
          const listado = response.data.data;
          this.arrReglas = response.data.reglas;

          this.arrRegistrosTabla = listado.data;
          this.paginaActual = listado.current_page;
          this.cantidadPaginas = listado.last_page;
          this.primerRegistro = listado.from;
          this.ultimoRegistro = listado.to;
          this.totalRegistro = listado.total;

          this.alertRegistroNoEcontrado = this.arrRegistrosTabla.length === 0;
        })
        .catch((error) => {
          console.log(error.response);
        })
        .finally(() => {
          this.loaderListado = false;
        });
    },

    limpiarFiltros() {
      this.cmbCantidadRegistros = 30;
      this.cmbEstado = null;
      this.cmbRegla = null;
      this.iptFechaDesde = null;
      this.iptFechaHasta = null;
      this.iptBuscarRegisro = "";
      this.listarRegistros(1);
    },
  },

  created() {
    if (!this.validarPermiso("correosAutomaticos.listado")) {
      this.$toasted.error("Usted no tiene permisos para esta sección", {
        icon: "mdi-close",
      });

      this.$router.push({
        name: "inicioPanel",
      });
      return;
    }
    this.listarRegistros(1);
  },
};
</script>
